import React from "react";

function Contact() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 text-gray-100">
      <div className="max-w-md w-full p-6 rounded-2xl bg-slate-800 shadow-lg">
        <h1 className="text-2xl font-semibold mb-4">Contact Us</h1>
        <p className="text-sm mb-4">
          Contact us for any queries.
        </p>

        <div className="text-sm mb-4 space-y-1">
          <p>
            📧 Aditya Deshpande:{" "}
            <a href="mailto:#" className="underline">
              aditya dot deshpande at unifr dot ch
            </a>
          </p>
          <p>
            📧 Beatrice Gervasini:{" "}
            <a href="mailto:#" className="underline">
              beatrice dot gervasini at unifr dot ch
            </a>
          </p>
         
        </div>

        <a
          href="/"
          className="inline-block mt-6 text-sm underline text-blue-400"
        >
          ⬅ Back to chat
        </a>
      </div>
    </div>
  );
}

export default Contact;
